<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroTrinappSuite" />
    <Section :content="pods" />
    <Section :content="documents" />
    <SectionDigitalTwin />
    <SectionSearchAPI />
    <Section :content="anyDeviceSize" :videoHeightOverride="true" />
    <CallToAction :content="buildingCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionDigitalTwin from '../components/section-digital-twin.vue';
import SectionSearchAPI from '../components/section-search-api.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'TrinApp',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionDigitalTwin,
    SectionSearchAPI,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroTrinappSuite: { 
        eyebrowIcon: 'launchpad.png',
        eyebrowTitle: 'The Building Knowledge Accelerator',
        eyebrowSubtitle: '',
        header: 'TrinApp\u2122 Suite',
        subheader: 'Convert documents and files into linked intelligentPDF\u2122, visualize and navigate systems, and fine-tune collaboration with granular access controls. Whether at the office or on site, the TrinApp™ suite of apps can be used on any internet connected device.',
        img: 'trinapp-suite-globe.png',
        videoId: '',
        buttons: [
          { label: 'Pods', path: '', id: 'pods' },
          { label: 'Documents', path: '', id: 'documents' },
          { label: 'Digital Twin', path: '', id: 'digital-twin' },
          { label: 'Search API', path: '', id: 'search-api' },
          { label: 'Any Device Size', path: '', id: 'any-device' },
        ]
      },
      pods: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Pods',
        headlineIcon: 'trinapp_projects.png',
        paragraphs: [
          'Manage and create pods including employees, members, and global collaboration.'
        ],
        id: 'pods',
        image: 'scp-pods.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
      },
      documents: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Documents',
        headlineIcon: 'trinapp_cde.png',
        paragraphs: [
          'Manage documents and files, bulk upload from zip, run Crosslink individually or in bulk to create intelligentPDF\u2122.'
        ],
        id: 'documents',
        image: 'bracing-documents.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
      },
      anyDeviceSize: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Use On Any Device Size',
        headlineIcon: '',
        paragraphs: [
          'Whether at the office or on site, the TrinApp™ suite of apps can be used on any internet connected device.'
        ],
        id: 'any-device',
        image: '',
        videoId: '895763098',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
      },
      buildingCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
